"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecruitmentOverviewApiResponseSchema = exports.recruitmentCitySchema = void 0;
const zod_1 = require("zod");
exports.recruitmentCitySchema = zod_1.z.object({
    name: zod_1.z.string(),
    /** False renders the chip as "· bientôt" — see `Office.open`. */
    open: zod_1.z.boolean(),
});
exports.getRecruitmentOverviewApiResponseSchema = zod_1.z.object({
    cities: zod_1.z.array(exports.recruitmentCitySchema),
    officeCount: zod_1.z.number(),
    siteCount: zod_1.z.number(),
});
